// pagesFaq.js
//
// Content for the Help & Support page (src/components/pages/FaqPage.vue).
// Common issues grouped by topic, plus the support contact address. Edit
// this file to change what users see there — same convention as
// pagesGuide.js: one file owns the copy, the page just renders it.

export const SUPPORT_EMAIL = "rentalkenya001@gmail.com";

export const faqTopicOrder = [
  "Account & login",
  "Properties & units",
  "Tenants",
  "Billing & payments",
  "SMS",
  "Something's not working",
];

export const faqTopics = {
  "Account & login": [
    {
      q: "It says my account isn't verified and won't let me log in",
      a: "New accounts need a one-time verification code before they can log in. On the login screen, use the verification prompt to enter the code sent to you, or go to Send OTP to request a new one if it expired.",
    },
    {
      q: "I forgot my password",
      a: "Use \"Forgot password\" on the login page. You'll get an email to reset it — the reset link only works once and expires after a while, so request a fresh one if it stops working.",
    },
  ],
  "Properties & units": [
    {
      q: "How do I add a new property?",
      a: "Go to Houses and use \"Add property\" to register it, then add its units from the house's page — either one at a time or by uploading a CSV.",
    },
    {
      q: "A unit still shows as vacant after I assigned a tenant (or vice versa)",
      a: "Occupancy is driven by the assignment itself: assigning a tenant to a unit marks it occupied, and vacating a tenant marks it vacant again. If a unit looks wrong after doing this, refresh the page — the list doesn't always update instantly.",
    },
  ],
  Tenants: [
    {
      q: "How do I add a tenant?",
      a: "Go to Tenants → Add tenant. You can add one at a time, or drop a CSV to add several at once from the same page.",
    },
    {
      q: "Can one tenant hold more than one unit?",
      a: "Yes — assign them to each unit separately from Assign tenant on the unit's page. Their tenant record stays the same; only the unit link changes.",
    },
  ],
  "Billing & payments": [
    {
      q: "I recorded a payment but the tenant's balance didn't change",
      a: "Double check the payment was saved against the right tenant on Receive payment — it updates the balance immediately once submitted. If it's still wrong, check Payments to confirm the record actually went through.",
    },
    {
      q: "How do I let tenants pay directly (e.g. M-Pesa)?",
      a: "Set up a paybill or till number under Create paybill. Leave the shortcode blank if you're using a standard Safaricom paybill.",
    },
    {
      q: "How do I generate an invoice?",
      a: "Invoices are built from billings — add the relevant bills first (Add billing / Monthly billings), then create the invoice from Invoices.",
    },
  ],
  SMS: [
    {
      q: "A tenant says they didn't get my SMS",
      a: "Check SMS history for that message's delivery status. If it shows as failed, confirm the tenant's phone number on their profile is correct and try resending.",
    },
    {
      q: "How do I message all my tenants at once?",
      a: "Go to Message tenants, tick the tenants you want to reach (or select all), write your message, and send.",
    },
  ],
  "Something's not working": [
    {
      q: "A page seems slow or won't load",
      a: "This usually clears up within a few minutes. If it's still happening after that, email support below with what page you were on and roughly when it happened.",
    },
    {
      q: "I got an error uploading a CSV file",
      a: "Make sure the file is a plain .csv (not .xlsx) and its columns match what the upload page shows as expected. A single malformed row is the most common cause of a failed upload.",
    },
  ],
};
